import React from 'react';

const DocumentPreview = ({ documentUrl }) => {
  if (!documentUrl) return <p>Tidak ada dokumen.</p>;

  const getFileExtension = (url) => {
    try {
      const pathname = new URL(url).pathname;
      return pathname.split('.').pop().toLowerCase();
    } catch {
      return "";
    }
  };

  const fileExtension = getFileExtension(documentUrl);

  const renderPreview = () => {
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
      return (
        <img
          src={documentUrl}
          alt="Document Preview"
          style={{ maxWidth: "100%", maxHeight: "300px" }}
        />
      );
    }
    if (fileExtension === "pdf") {
      return (
        <iframe
          src={documentUrl}
          width="100%"
          height="500px"
          title="Document Preview"
        ></iframe>
      );
    }
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)) {
      return (
        <a
          href={documentUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm btn-outline-primary"
        >
          Download & Preview {fileExtension.toUpperCase()}
        </a>
      );
    }
    return <p>Preview tidak tersedia untuk jenis file ini.</p>;
  };

  return <div>{renderPreview()}</div>;
};

export default DocumentPreview;
